{
    "workflows": {
        "openReadOnly": "Öppna skrivskyddad",
        "readOnly": {
            "label": "Skrivskyddad",
            "description": "Den här stegkonfigurationen kan inte ändras. Markera och kopiera ett värde, eller kopiera hela konfigurationen.",
            "copyConfiguration": "Kopiera konfiguration",
            "copySuccess": "Stegkonfigurationen kopierades till urklipp.",
            "copyError": "Det gick inte att kopiera stegkonfigurationen."
        },
         "active": "Aktiv Workflow",
         "importWorkflow": "Importera arbetsflöde",
         "importWorkflowTooltip": "När detta är valt är arbetsflödet konfigurerat för att importera/ladda upp data från ett Excel-kalkylblad vid körning. Arbetsflödet bearbetar den uppladdade datan och aktiverar de tillhörande API:erna. Dessa API:er kan utföra antingen import- eller exportoperationer beroende på arbetsflödets konfiguration.",
        "unsavedPopover": {
            "title": "Osparade ändringar",
            "message": "Du har osparade ändringar i arbetsflödet \"{title}\". Vill du spara arbetsflödet?",
            "saveAndContinue": "Spara och fortsätt"
        },
        "addUserInstructions": "Lägg till ny",
        "allWorkflows": "Alla arbetsflöden",
        "designFile": "Designfil",
        "designFileSaved": "Designfilen uppdaterades",
        "lookupWorkflow": "<strong>Uppslagsnamn:</strong> {lookup}  <strong>Arbetsflödesnamn:</strong> {workflow}",
        "configurationExecutionKeys": "Konfigurationskörningsnycklar ({current}/{maximum})",
        "keyName": "Namn",
        "expression": "JSONata-uttryck",
        "addNewExecutionKey": "Ny nyckel",
        "type": "Arbetsflödestyp",
        "nameIsRequired": "Fältet är obligatoriskt",
        "nameNotPermitted": "Du har inte behörighet att skapa ett arbetsflöde med det här namnet",
        "nameHasSpecialChars": "Specialtecken: / $ * ? {'{'} {'}'} [ ] & % är inte tillåtna",
        "validation": {
            "keyNameRequired": "Nyckelnamn krävs",
            "invalidExpression": "Ogiltigt JSONata-uttryck",
            "expressionRequired": "Uttryck krävs"
        },
        "api": {
            "addApi": "Add API",
            "alreadyExists": "already exists!",
            "apiOptions": "API Options",
            "basedOnTransaction": "Based on transaction",
            "code": "Code",
            "componentSettings": "Component settings",
            "connections": "Tilkoblinger",
            "constant": "Constant",
            "critical": "Critical",
            "currentDate": "Nåværende Dato",
            "done": "Done",
            "editElement": "Edit element",
            "endRun": "End Run",
            "enterRows": "Enter rows",
            "enterValue": "Enter value",
            "environment": "Miljø",
            "fromApi": "From API",
            "fromClient": "From Client",
            "fromEvent": "From Event",
            "fromExcel": "From Excel",
            "fromTag": "från Tag",
            "group": "Group",
            "groupedBy": "Grouped By",
            "includeGeneralTransactions": "Inkluder generelle Transaksjoner",
            "input": "Input",
            "inputs": "Inputs",
            "mapped": "Mapped",
            "max": "Max",
            "maxRows": "Max rows",
            "messages": {
                "configureOneTransaction": "API: Configure at least one Transaction",
                "mandatoryFieldNotMapped": "API: Mandatory field not mapped: {input}"
            },
            "name": "Name",
            "output": "Output",
            "outputs": "Outputs",
            "overview": "Overview",
            "pleaseEnterValue": "Please enter value",
            "program": "Program",
            "programName": "Program Name",
            "runOn": "Run On",
            "select": "Select",
            "selectSource": "Select Source",
            "source": "Source",
            "startRun": "Start Run",
            "transaction": "Transaction",
            "transactionName": "Transaction Name",
            "view": "View",
            "workflowSpreadsheet": "Workflow uses spread sheet data?"
        },
        "notification": {
            "status": {
                "finished": "slutförd",
                "started": "startad",
                "stepcomplete": "pågår",
                "failed": "misslyckades"
            },
            "view": "Visa",
            "workflow": "Arbetsflöde {workflowName} {status}"
        },
           "runWorkflow": {
            "errors": {
                "hasError": " Det finns fel i arbetsflödet. Åtgärda felen innan du kör arbetsflödet.",
                "noEnvironments": "Inga miljöer tillgängliga för körning",
                "connectionsLoadFailed": "Det gick inte att läsa in anslutningar",
                "environmentsLoadFailed": "Det gick inte att läsa in miljöer",
                "noConnections": "Inga anslutningar tillgängliga för körning"
            },
            "execute": "Kör",
            "tooltips": {
                "openLookupDialog": "Öppna uppslagsdialog"
            }
        },

        "cancelEditor": "Annullera",
        "client": {
            "addFilterInput": "Add filter input",
            "addInput": "Add input",
            "apiDetails": "API Details",
            "browseControl": "Browse control",
            "buttonText": "Button Text",
            "changeText": "Change Text",
            "clientConfiguration": "Client configuration",
            "clientSettings": "Client settings",
            "customRequired": "Make Mandatory",
            "dateField": "Date field",
            "defaultValue": "Default value",
            "fields": "Fields",
            "input": "Input",
            "lookup": "Lookup",
            "placeholder": "Placeholder",
            "settings": "Settings",
            "tagField": "Tag",
            "textField": "Text field",
            "title": "Client",
            "tooltip": "Tooltip",
            "type": "Type"
        },
        "closeConfirmation": "Do you want to save pending changes?",
        "closeConfirmationTitle": "Please confirm",
        "closeEditor": "Stänga",
        "code": {
            "codeEditor": "Code editor"
        },
        "component": "Component",
        "componentSettings": "Component settings",
        "components": "Components",
        "connection": "Connection",
        "createdBy": "Created by",
        "createdDate": "Skapat datum",
        "dataLake": {
            "title": "Data lake",
            "connectionId": "Anslutning",
            "connectionPlaceholder": "Välj eller skriv ett anslutnings-ID...",
            "endpoint": "Endpoint-URL",
            "endpointPlaceholder": "https://api.example.com/path",
            "body": "Fråga",
            "bodyPlaceholder": "Ange din fråga...",
            "advanced": "Avancerat",
            "saveAsFile": "Spara även utdata som fil"
        },
        "fileUploader": {
            "messages": {
                "connectionRequired": "Anslutning krävs",
                "itemRequired": "Sökväg krävs"
            },
            "title": "Filuppladdare",
            "connection": "Anslutning",
            "webUrl": "Sökväg",
            "browse": "Bläddra"
        },
        "transformerMorph": {
            "inputOrTemplateMissing": "Ange indata och jsonata-mall",
            "title": "Transform",
            "input": "Indata",
            "output": "Utdata",
            "help": "Lär dig JSONata-syntax",
            "executionId": "Arbetsflödeskörnings-ID",
            "executionIdPrompt": "Läs exempeldata och simulera $context med faktiska värden från en arbetsflödeskörning",
            "transformation": "JSONata-uttryck",
            "loadExecution": "Läs",
            "executionIdSuccessMessage": "Data laddades framgångsrikt för körnings-ID {executionId}",
            "noExecutionFound": "Ingen arbetsflödeskörning hittades",
            "executionIdErrorMessage": "Fel vid laddning av körning",
            "copyToClipboard": "Kopiera till urklipp",
            "copySuccessMessage": "JSONata-uttryck kopierat till urklipp",
            "copyErrorMessage": "Fel vid kopiering av JSONata-uttryck till urklipp"
        },
        "saveError": "Fel vid lagring av arbetsflöde",
        "genericFilter": {
            "filterFieldPlaceholder": "Ange {fact} för att filtrera"
        },
        "genericCode": {
            "title": "Stegkodredigerare"
        },
        "genericApi": {
            "title": "Rest API",
            "version": "Version",
            "versionDescription": "Komponentversion",
            "connection": "Använd anslutning",
            "connectionId": "Anslutning",
            "connectionPlaceholder": "Välj eller skriv ett anslutnings-ID...",
            "endpoint": "Endpoint-URL",
            "endpointPlaceholder": "https://api.example.com/path",
            "method": "HTTP-metod",
            "methodWarning": "Okänd metod. Förväntar en standard HTTP-metod eller ett handlebars-uttryck",
            "headers": "Headers",
            "addHeader": "Lägg till header",
            "headerKey": "Nyckel",
            "headerValue": "Värde",
            "bodyMode": "Begärandekropp",
            "bodyModeOption": {
                "bodyPath": "Body path",
                "body": "Body"
            },
            "bodyPathDescription": "Referera data från ett tidigare steg",
            "bodyDescription": "Definiera begärandekroppen",
            "bodyPathLabel": "JSONata body path-uttryck",
            "bodyLabel": "Begärandekropp JSON",
            "advanced": "Avancerat",
            "skipIfExpression": "Hoppa över om uttryck",
            "skipIfExpressionDescription": "Ett JSONata-uttryck som, om det utvärderas till sant, hoppar över detta steg",
            "forEach": "För varje",
            "forEachDescription": "Sökväg till en array från ett tidigare steg att iterera över (t.ex. body.records)",
            "parallel": "Parallella körningar",
            "parallelDescription": "Antal samtidiga förfrågningar att köra parallellt (max 20)"
        },
        "runtimeConfig": {
            "title": "Konfigurera körningsmiljöer",
            "connectionAliases": "Anslutningsalias",
            "connectionAliasesHelp": "Varje system löses vid körning till den anslutning som är mappad för den valda miljön.",
            "alias": "System",
            "aliasPlaceholder": "Lägg till ytterligare system",
            "aliasValidation": "Endast små bokstäver, siffror och understreck tillåtna",
            "aliasDuplicate": "Detta system finns redan",
            "addAlias": "Lägg till system",
            "environments": "Miljöer",
            "default": "Standard",
            "setDefault": "Ange som standard",
            "connections": "Anslutningsmappningar",
            "selectConnection": "Välj anslutning...",
            "noAliasesYet": "Inga anslutningsalias definierade ännu. Lägg till alias ovan först.",
            "variables": "Variabler",
            "variableKey": "Nyckel",
            "variableValue": "Värde",
            "addEnvironmentPlaceholder": "Lägg till miljö...",
            "emptyState": "Lägg till en miljö för att komma igång. Anslutningar upptäcks automatiskt.",
            "noDefinitionError": "Arbetsflödet har ingen definition, kan inte spara."
        },
        "deleteAPI": "Delete API",
        "deleteComponent": "Delete component",
        "deleteItem": "Är du säker på att du vill radera \"{workflowName}\"?",
        "deleteItemFromDashboard": "Är du säker på att du vill radera \"{workflowName}\"? Detta arbetsflöde är kopplat till Dashboard och {widgetCount} {widgetText}.",
        "deleteConfirmation": "Delete Confirmation",
        "deleteItemAPI": "Do you want to delete the API {APIName}?",
        "deleteUserInstructions": "Radera",
        "deleteLastStepError": "Det sista arbetsflödessteget kan inte tas bort. \n Lägg till ett annat steg först, eller ta bort hela arbetsflödet.",
        "deleteUserInstructionsConfirmationMessage": "Denna åtgärd kommer att radera användarinstruktionerna permanent, är du säker på att du vill fortsätta?",
        "deleteUserInstructionsConfirmationTitle": "Bekräfta radering",
        "description": "Workflow Beskrivning",
        "editor": {
            "addComponent": "Add Component",
            "api": "API",
            "code": "Code",
            "componentToStartWorkflow": "Select a Component to start from workflow",
            "converter": "Converter",
            "createFromScratch": "...Or Create from Scratch",
            "createFromTemplate": "Create from Template...",
            "dataLake": "Data lake",
            "database": "Database",
            "email": "Email",
            "excel": "Excel",
            "exportToExcel": "Export from M3",
            "fileLoader": "File Loader",
            "filter": "Filter",
            "genericFilter": "Generisk Filter",
            "importToAPI": "Import to M3",
            "lookup": "Lookup",
            "notification": "Notification",
            "restApi": "Rest API",
            "sms": "SMS",
            "storeApiToTable": "Store data from M3 to Table",
            "table": "Table",
            "tableUpdater": "Table updater",
            "transform": "Transform",
            "trigger": "Trigger",
            "widget": "Widget"
        },
        "email": {
            "sourceType": {
                "NONE": "Ingen",
                "FILE": "Genererade filer",
                "DATA": "Rådata"
            },
            "noFileSourceSteps": "Inga föregående steg kan producera en fil",
            "sourceTypeHint": {
                "FILE": "Bifoga en fil producerad av ett kompatibelt tidigare steg (t.ex. {stepNames})",
                "DATA": "Bifoga rådata från ett tidigare steg i JSON-format"
            },
            "body": "Meddelande",
            "sourceStep": "Källsteg för data",
            "noSourceSteps": "Inga källsteg som kan producera data är tillgängliga",
            "addresses": "Adresser",
            "content": "E-postinnehåll",
            "attachment": "Bilagor",
            "isHTML": "HTML",
            "htmlHelp": "Bör väljas om användaren använder HTML-kod i Transform- eller Email-steg.",
            "editorTabs": {
                "visual": "Visuell editor",
                "html": "HTML-editor",
                "preview": "Förhandsgranskning"
            },
            "toolbar": {
                "heading": "Rubrik",
                "subheading": "Underrubrik",
                "normal": "Normal"
            },
            "attachmentIndicators": {
                "none": "--",
                "data": "<>"
            },
            "subject": "Ämne",
            "invalidEmail": "Ogiltig e-post",
            "to": "Till",
            "addCc": "Lägg till cc-adresser",
            "cc": "Cc",
            "bcc": "Bcc",
            "addBcc": "Lägg till bcc-adresser",
            "title": "E-postavsändare",
            "fieldNames": {
                "toAddress": "Till-adress",
                "subject": "Ämne",
                "body": "Meddelande"
            },
            "requiredFieldsWarning": "Fyll i {fields} eller ta bort e-poststeget."
        },
        "enterDescription": "Enter description",
        "enterEmail": "Enter email",
        "enterName": "Enter name",
        "environment": "Environment",
        "event": {
            "eventConfiguration": "Event Configuration",
            "title": "Event"
        },
        "excel": {
            "selectAll": "Välj alla",
            "showSelected": "Visa valda",
            "fromSource": "Från {source}",
            "chooseTheFile": "Choose a file",
            "columnStyleApplied": "Column Style applied to Column",
            "columnToLeft": "Add Column to Left",
            "columnToRight": "Add Column to Right",
            "controlSpreadSheet": "Control spreadsheet",
            "descriptionRow": "Beskrivningsrad",
            "mappingRow": "Mappningsrad",
            "dataRow": "Data row",
            "unsetMappingRow": "Avmarkera som mappningsrad",
            "setMappingRow": "Markera som mappningsrad",
            "setDescriptionRow": "Markera som beskrivningsrad",
            "deleteCell": "Delete Cell",
            "deleteConfirmation": "Delete Confirmation",
            "deleteContent": "Delete Content",
            "deleteDesignFile": "Ta bort designfil",
            "deleteDesignFileConfirmation": "Bekräfta om du vill fortsätta och ta bort designfilen permanent.",
            "deleteInputItem": "Do you want to remove {item} from the mapping section of API Editor?",
            "deleteOutputItem": "Do you want to remove {item} from the mapping?",
            "designFileAlert": "Bekräfta din uppladdning genom att spara arbetsflödet",
            "endColumn": "end column",
            "enforceSheetVerification": "Framtvinga bladverifiering",
            "environment": "Show used environment on execution",
            "environmentMessageColumn": "Environment Message Column",
            "excelSetting": "Excel setting",
            "excelSettings": "Inställningar",
            "importWorkflowRequiredMessage": "För att använda Excel-mappning för indata måste det här arbetsflödet konfigureras som ett importarbetsflöde.\nVill du aktivera importarbetsflöde?",
            "groupBy": "Group by",
            "headerRow": "Header row",
            "input": "Input",
            "messages": {
                "mapField": "EXCEL: Map {input} field for excel",
                "mapOneInputFieldExcel": "EXCEL: Mappa minst ett inmatningsfält för excel",
                "mapOneOutputFieldExcel": "EXCEL: Mappa minst ett utmatningsfält för excel"
            },
            "next": "Next",
            "options": "Options",
            "output": "Output",
            "removeGroupBy": "Remove group by",
            "removeSortBy": "Remove sort by",
            "removeTargetSheet": "Remove Target Sheet",
            "rowStyleApplied": "Row Style applied to Row",
            "saveBackup": "Save backup of output",
            "secondaryHeaderRow": "Secondary Header row",
            "selectDifferentSheets": "Please select different sheets as Source and target Sheet",
            "sheetName": "Sheet name",
            "sortBy": "Sort by",
            "sourceSheet": "Source Sheet",
            "startColumn": "Start column",
            "style": "Style",
            "styleHeader": "Apply Style to header",
            "targetSheet": "Target Sheet",
            "title": "Excel",
            "toggleHeader": "Toggle Header",
            "twoHeaders": "Two Headers",
            "upload": "Upload",
            "showMappingValues": "Visa mappningsvärden",
            "hideMappingValues": "Dölj mappningsvärden",
            "horizontalNoLeftColumn": "Horisontell layout kräver en kolumn till vänster om släppcellen för fältetiketten",
            "workflow": "Workflow",
            "workflowMessageColumn": "Workflow Message Column",
            "template": {
                "singleHeader": "Enkel rubrik",
                "doubleHeader": "Dubbel rubrik"
            },
            "preview": {
                "sourceSheet": "Källark",
                "headerRow": "Mapping row",
                "secondaryHeaderRow": "Description row",
                "dataRow": "Datarad",
                "applyTooltip": "Mappnings- eller beskrivningsrader har ändrats. Klicka här för att köra automappning igen.",
                "startColumn": "Startkolumn",
                "endColumn": "Slutkolumn",
                "targetSheet": "Målark",
                "addTargetSheet": "Lägg till målark",
                "removeTargetSheet": "Ta bort målark",
                "targetSheetWarning": "Käll- och målark får inte vara samma sak. Välj olika ark för källa och mål.",
                "sheetView": "Arkvy",
                "sourceLabel": "Källa",
                "targetLabel": "Mål",
                "validation": {
                    "headerOrMappingRequired": "Minst en av beskrivningsraden eller mappningsraden krävs.",
                    "headerAndMappingSameRow": "Beskrivnings- och mappningsraderna får inte vara samma rad.",
                    "dataRowAfterHeader": "Dataraden måste komma efter beskrivningsraden.",
                    "dataRowAfterMapping": "Dataraden måste komma efter mappningsraden.",
                    "applyRowsZero": "Radnummer får inte vara noll eller mindre än noll.",
                    "applyRowsConflict": "Dataraden måste komma efter Beskrivnings- och Mappningsraderna.",
                    "unappliedRowChangesSource": "Källfliken har otillämpade radändringar. Klicka på ✓ för att tillämpa dem.",
                    "unappliedRowChangesTarget": "Målfliken har otillämpade radändringar. Byt till Målfliken och klicka på ✓ för att tillämpa dem.",
                    "unappliedRowChangesBoth": "Både Käll- och Målflikarna har otillämpade radändringar. Klicka på ✓ på varje flik för att tillämpa dem."
                }
            },
            "editCell": "Redigera cell",
            "largeColumnCountWarning": "Du har mappat ett stort antal kolumner ({count}). Detta kan överskrida systemgränserna och göra att sparningen misslyckas."
        },
        "m3Api": {
            "unmappedRequiredInputs": "Följande obligatoriska indata är inte mappade: {inputs}",
            "removeStartEnd": "Inaktivera start-slut",
            "addStartEnd": "Aktivera start-slut",
            "updateGrouping": "Extra gruppering",
            "existingGroupings": "Grupperingar på fältnivå",
            "extraGroupings": "Extra gruppering",
            "apiGroupings": "API-postgrupperingar",
            "groupBy": "Gruppera efter detta fält",
            "hasGrouping": "Resultatet kommer att grupperas efter detta fält",
            "runStartEndTitle": "Definiera start-slut-körning",
            "selectTag": "Välj tagg",
            "defineStartEnd": "Definiera start-slut-körning",
            "start": "Starta transaktion",
            "end": "Avsluta transaktion",
            "deleteDependency": "Ta bort beroende",
            "fail": "misslyckas",
            "success": "körs framgångsrikt",
            "condition": "Villkor",
            "selectTransaction": "Transaktion",
            "dependency": "Kör \"{apiLabel}\" om",
            "updateDependency": "Beroenden",
            "deleteOutput": "Ta bort utdata - detta fält kommer inte att vara tillgängligt i uppslag",
            "addOutput": "Lägg till utdata - detta fält blir tillgängligt i uppslag",
            "sources": {
                "CONSTANT": "Konstant",
                "CLIENT": "Klient",
                "API": "API",
                "EXCEL": "Excel",
                "TEXT": "Text",
                "EVENT": "Händelse",
                "CONTEXT": "Kontext",
                "TAG": "Tagg",
                "CURRENT_DATE": "Dagens datum",
                "_": "Ingen"
            },
            "openFieldConfig": "Öppna konfiguration för parametermappning",
            "client": "Hämta värde från",
            "newClientField": "Nytt klientfält",
            "showGeneralTransactions": "Inkludera allmänna transaktioner",
            "parameterRequiredAndNotMapped": "Parameter är obligatorisk men inte mappad",
            "parameterNotRequiredAndNotMapped": "Parameter är inte obligatorisk och inte mappad",
            "apiCall": "API-anrop",
            "output": "Utdata-parameter",
            "mappedOutputHeader": "Mappad utdata",
            "selectApiFirst": "Välj API först",
            "constantValue": "Konstant värde",
            "constantValueRequired": "Konstant värde krävs",
            "tagRequired": "Tagg krävs",
            "availableSources": "Tillgängliga källor",
            "selectSource": "Välj källa",
            "removeSource": "Ta bort källa",
            "sourceTitle": "Fältkonfiguration för {name}",
            "copyPrefix": " (kopia %n)",
            "deleteApiConfirmation": "Är du säker på att du vill ta bort API-anropet?",
            "deleteApiHeader": "Borttagning av API-anrop",
            "source": "Källa",
            "value": "Värde",
            "m3Company": "M3-företag",
            "m3Division": "M3-division",
            "maxRows": "Max antal rader",
            "unlimited": "Obegränsat",
            "companyMustBeNumeric": "M3-företag måste vara ett numeriskt värde",
            "executionConfig": "Körningskonfiguration",
            "name": "Namn",
            "configureExecution": "Konfigurera körning",
            "addFirstApi": "Klicka här för att lägga till första API-anropet",
            "noEnvironmentSelected": "Inga miljöer valda",
            "selectEnvironment": "Välj miljö",
            "transactionSelectTitle": "Välj transaktion att köra",
            "program": "Program",
            "selectProgram": "Välj program först",
            "transaction": "Transaktioner",
            "copy": "Kopiera",
            "setCritical": "Sätt som kritisk",
            "unsetCritical": "Ta bort kritisk status",
            "inputsHeader": "Indata",
            "outputHeader": "Utdata",
            "addItem": "Lägg till API-post på denna position",
            "eventColumn": "Event column",
            "title": "M3 API",
            "selected": "valda"
        },
        "execute": {
            "advanced": "Advanced",
            "browse": "Browse",
            "chooseTheFile": "Choose a file",
            "dropTheFile": "Drop file here...",
            "logLevel": "Log Level",
            "logLevelList": {
                "detailed": "Detailed",
                "failures": "Failures",
                "info": "Info"
            },
            "result": {
                "done": "Färdig",
                "duration": "Duration",
                "failedRecords": "Failed Records:",
                "files": "Filer",
                "recordsProcessed": "Records Processed:",
                "stepId": "Steg-ID",
                "success": "Step Success:",
                "successfulRecords": "Successful Records:",
                "title": "Resultat",
                "trigger": "Trigger File",
                "waitingToStart": "Väntar på att starta",
                "workflowEnded": "Workflow ended",
                "workflowFailed": "Workflow failed!",
                "workflowRunning": "Workflow running...",
                "workflowRunningInBackground": "Workflow is still running in the background. (Soon you'll be able to see the execution log for all executions)",
                "workflowStarted": "Workflow startat",
                "failedToDownloadTriggerFile": "Misslyckades att ladda ner triggerfil",
                "noTriggerFile": "Ingen triggerfil tillgänglig"
            },
            "schedule": {
                "daily": {
                    "day": "day",
                    "title": "Daily"
                },
                "day": "Day",
                "every": "Every",
                "everyWeekDay": "Every week day",
                "hourly": {
                    "hour": "hour",
                    "title": "Hourly"
                },
                "minutes": {
                    "minutes": "minutes",
                    "title": "Minutes"
                },
                "monthly": {
                    "month": "month",
                    "title": "Monthly"
                },
                "monthsOptions": {
                    "april": "April",
                    "august": "August",
                    "december": "December",
                    "february": "February",
                    "january": "January",
                    "july": "July",
                    "june": "June",
                    "march": "March",
                    "may": "May",
                    "november": "November",
                    "october": "October",
                    "september": "September"
                },
                "of": "of",
                "ofEvery": "of every",
                "periodOptions": {
                    "first": "First",
                    "fourth": "Fourth",
                    "second": "Second",
                    "third": "Third"
                },
                "scheduler": "Scheduler",
                "startTime": "Start time",
                "the": "The",
                "weekly": {
                    "friday": "Friday",
                    "monday": "Monday",
                    "saturday": "Saturday",
                    "sunday": "Sunday",
                    "thursday": "Thursday",
                    "title": "Weekly",
                    "tuesday": "Tuesday",
                    "wednesday": "Wednesday"
                },
                "yearly": {
                    "title": "Yearly"
                }
            }
        },
        "export": "Export",
        "failure": "Failure",
        "fileLoader": {
            "fileLoader": "File Loader",
            "messages": {
                "info": "If the folder has multiple files, the most recently edited will be picked by default",
                "missingConnection": "FILE LOADER: Please select a connection",
                "missingFile": "FILE LOADER: Please select a file"
            }
        },
        "filter": {
            "action": "Action",
            "all": "All",
            "field": "Field",
            "fieldSource": {
                "constant": "Constant",
                "fromClient": "From Client"
            },
            "filterConditions": {
                "blank": "Is Blank",
                "contains": "Contains",
                "doesNotContain": "Does Not Contain",
                "equal": "Equal",
                "greaterThan": "Greater Than",
                "greaterThanEqual": "Greater than Equal",
                "lessThan": "Less Than",
                "lessThanEqual": "Less than Equal",
                "notBlank": "Is Not Blank",
                "notEqual": "Not Equal"
            },
            "filterConfiguration": "Filter configuration",
            "logicalType": "Logical Type",
            "logicalTypes": {
                "and": "AND",
                "or": "OR"
            },
            "messages": {
                "mapOneFieldFilter": "M3-FILTER: Mappa minst ett fält för att filtret ska fungera",
                "missingConstantValue": "FILTER: Missing value for Constant in {filterDescription}",
                "missingLogicalType": "FILTER: Missing Logical Type for {filterDescription}",
                "missingSource": "FILTER: Missing source for {filterDescription}",
                "missingType": "FILTER: Missing Type for {filterDescription}"
            },
            "noApiFound": "No API found",
            "selectFields": "Select Fields",
            "source": "Source",
            "type": "Type"
        },
        "filterText": "Filter",
        "filters": "Filters",
        "import": "Import",
        "inputFields": "Input fields",
        "invalidWorkflow": "Invalid workflow",
        "lastExecuted": "Last executed",
        "logLevel": "Log Level",
        "logLevelList": {
            "detailed": "Detailed",
            "failures": "Failures",
            "info": "Info"
        },
        "logs": {
            "AvgTimePerRecord": "AvgTimePerRecord",
            "AvgTimePerTransaction": "AvgTimePerTransaction",
            "action": "Action",
            "auditLogs": "Audit Logs",
            "downloadDataContents": "Ladda ner datainnehåll",
            "durationMs": "Duration (ms)",
            "endTime": "End time",
            "environmentLogs": {
                "rerunEnvironment": {
                    "title": "Confirm Re-run"
                }
            },
            "fails": "Mislyckas",
            "joblog": "Job Log",
            "logDetails": "Log details",
            "logType": "Log Type",
            "logTypeList": {
              "all": "Alla",
              "failed": "Misslyckad",
              "ok": "OK",
              "verified": "Verifierad",
              "retried": "Omstartad",
              "started": "Startad"
            },
            "logs": "Logs",
            "message": "Message",
            "program": "Program",
            "startTime": "Start time",
            "status": "Status",
            "success": "Framgång",
            "time": "Time",
            "title": "Workflow logs",
            "transaction": "Transaktion",
            "type": "Type",
            "rerun": "Kör om workflow",
            "verify": "Markera som verifierad",
            "resultJson": {
                "errorTitle": "Det gick inte att ladda ner resultatdetaljer",
                "download": "Ladda ner resultatdetaljer",
                "copyToClipboard": "Kopiera till urklipp",
                "copySuccessMessage": "Resultatdetaljer kopierade till urklipp",
                "copyErrorMessage": "Fel vid kopiering av resultatdetaljer till urklipp"
            },
            "findOriginal": "Hitta original"
        },
        "manual": "Manual",
        "messages": {
            "configureOneComponent": "Please configure at least one component",
            "couldNotSaveWorkflow": "Could not save the workflow!",
            "enterNotificationEmail": "Please enter notification Email",
            "enterValidWorkflow": "Please enter a valid workflow name.",
            "errorOccured": "Error occured while executing the workflow!",
            "executionComplete": "Execution complete!",
            "fileNotFound": "File or directory not found. Please check if the uploaded file exists or has been renamed.",
            "invalidGenericFilter": "Välj logisk typ för alla rader i Generic Filter",
            "invalidValue": "Invalid value %{input} for the field %{field}.",
            "m3APIMaxRowAlertText": "Om du vill ha mer än 99 999 poster, markera kryssrutan \"Obegränsat\".",
            "mandatoryField": "Please enter the mandatory field %{field}.",
            "maxValueExceed": "Value {input} for the field {field} has exceeded the maximum length {length}.",
            "permissionError": "Användare/roll har inte behörighet till {errorMessage}",
            "schdulerSavedWithErrors": "Error occurred in Scheduler configuration",
            "schedulerDelete": "Scheduler deleted successfully",
            "schedulerErrorAlertText": "{input} has missing values",
            "schedulerSavedSuccessfully": "Scheduler configured successfully",
            "specialCharError": "Special character's  / $ * ? {'{ }'} [ ]  not allowed in Workflow Name",
            "workflowNameExists": "Workflow name {workflowName} already exists!",
            "workflowNameRequired": "Workflow name is required",
            "workflowSavedSuccessfully": "Workflow saved successfully!",
            "workflowSavedWithErrors": "Workflow saved with following errors:"
        },
        "modifiedBy": "Modified by",
        "name": "Name",
        "navguardWarning": "You seem to have unsaved changes that will be lost if you leave this page. Do you wish to discard the changes and continue?",
        "newWorkflow": "New Workflow",
        "notificationEmail": "Email for Error reports",

        "notifyOnErrorTooltip": "Meddelar mottagaren/mottagarna vid varje fel",

        "notificationEmailHint": "Ange en eller flera e-postadresser, separerade med kommatecken. Används både för felmeddelanden när \"Notify on Error\" är markerat, och för allmänna fel som flera misslyckade schemalagda körningar.",
        "executionLogs": "Execution logs",
        "executionKeys": "Execution keys",
        "deleteWorkflow": "Delete workflow",
        "deactivateWorkflow": {
            "header": "Inaktivera arbetsflöde",
            "message": "Inaktivering av detta arbetsflöde kommer även att stoppa schemalagda körningar.",
            "confirm": "Ja, inaktivera"
        },
        "workflowActivatedSuccess": "Arbetsflödet aktiverades",
        "workflowDeactivatedSuccess": "Arbetsflödet inaktiverades",
        "groups": "grupper",
        "group": "grupp",
        "label": "etikett",
        "notifyOnError": "Notify on Error",
        "addActive": "Lägg till valda",
        "addAllActive": "Lägg till alla",
        "removeActive": "Ta bort valda",
        "removeAllActive": "Ta bort alla",
        "moveUp": "Flytta valt objekt uppåt",
        "moveTop": "Flytta valt objekt till toppen",
        "moveDown": "Flytta valt objekt nedåt",
        "moveBottom": "Flytta valt objekt till botten",
        "outputFields": "Output fields",
        "preview": "Preview",
        "previewData": "Preview Data",
        "recentlyViewed": "Recently Viewed",
        "favorite": "Lägg till favoriter",
        "unfavorite": "Ta bort från favoriter",
        "favorites": "Favoriter",
        "restApi": {
            "restApiConfiguration": "Rest API"
        },
        "runBy": "Run by",
        "scheduled": "Scheduled",
        "select": "Select",
        "settings": {
            "retryAttemptsNegetiveNumberValidation": "Bör inte vara under 0.",
            "retryAttemptsPositiveNumberValidation": "Bör inte överstiga gränsen 5."
        },
        "sms": {
            "maxlengthWarning": "{messageLength}/160 tecken",
            "messages": {
                "contentMaxLengthError": "SMS: content cannot exceed 160 characters",
                "invalidRecipientNumber": "Ogiltigt telefonnummer",
                "noContentError": "SMS: Content field cannot be blank",
                "noRecipientsError": "SMS: Recipients cannot be empty"
            },
            "recipientsLabel": "Ange mottagarens telefonnummer",
            "recipientsPlaceholder": "+1234567890",
            "smsConfiguration": "SMS Configuration",
            "smsContentPlaceholder": "Enter the message",
            "smsLabel": "Meddelande",
            "saveMessage": "Spara meddelande"
        },
        "status": {
            "active": "Active",
            "all": "All",
            "inactive": "Inactive",
            "title": "Status"
        },
        "success": "Success",
        "table": {
            "columnName": "Column Name",
            "columnToLeft": "Add Column to Left",
            "columnToRight": "Add Column to Right",
            "customTableConfig": "Custom table config",
            "dataType": "Data type",
            "deleteCell": "Delete Cell",
            "deleteContent": "Delete Content",
            "fieldName": "Field Name",
            "messages": {
                "missingPrimaryKey": "TABLE: Table is missing Primary key",
                "missingRecordCreationType": "TABLE: Table is missing Record Creation type",
                "missingTableName": "TABLE: Missing Table name",
                "tableNameExists": "TABELL: Tabellnamnet finns redan"
            },
            "primaryKey": "Primary key",
            "recordTypeList": {
                "append": "Append",
                "replace": "Replace",
                "upsert": "Upsert"
            },
            "removeField": "Remove field",
            "removePrimaryKey": "Remove Primary Key",
            "selectFields": "Select fields",
            "setPrimaryKey": "Set Primary Key",
            "tableAlias": "Table Alias",
            "tableDescription": "Table Description",
            "tableName": "Table Name",
            "tableRecordType": "Record creation type",
            "tableSettings": "Table settings",
            "showRecentWorkflows": "Visa senast visade arbetsflöden",
            "hideRecentWorkflows": "Dölj senast visade arbetsflöden",
            "sortByFavorites": "Sortera efter favoriter",
            "clearFavoriteSort": "Rensa favoritsortering"
        },
        "tableUpdater": {
            "messages": {
                "noTableSelectedWarning": "Table Updater: Please select a table.",
                "stepInfo": "Please note that the output from the previous step needs to have the keys marked with (P)."
            },
            "selectTableLabel": "Select a table",
            "tableUpdaterConfiguration": "Table updater"
        },
        "converter": {
            "saveAsFile": "Spara även utdata som fil"
        },
        "title": "Workflows",
        "transform": {
            "transformConfiguration": "Transform",
            "trimAllInputValues": "Trim all input values before transformation"
        },
        "m3filter": {
            "newValue": "Värde",
            "newConstant": "Ny",
            "noM3ApiItems": "Inga filterobjekt tillgängliga utan definierat M3 API",
            "dragItems": "Filtret har för närvarande inga objekt.",
            "clickToShow": "Klicka här för att visa tillgängliga fält",
            "dropBelow": "Dra objektet nedan för att lägga till filter",
            "filterItems": "Filterobjekt",
            "globalFilter": "Globalt filter",
            "constant": "Konstant",
            "defaultValue": "Standardvärde",
            "valueSourceOptions": {
                "CLIENT": "Klient",
                "CONSTANT": "Konstant"
            },
            "comparisonOptions": {
                "EQ": "Lika med",
                "NE": "Inte lika med",
                "LT": "Mindre än",
                "GT": "Större än",
                "LE": "Mindre eller lika med",
                "GE": "Större eller lika med",
                "BLANK": "Tom",
                "NOTBLANK": "Inte tom",
                "CONTAINS": "Innehåller",
                "NOTCONTAINS": "Innehåller inte"
            },
            "source": "Källa",
            "logicalOperator": "Logisk operator",
            "comparison": "Jämförelse",
            "title": "Filter",
            "openFields": "Visa tillgängliga fält",
            "closeFields": "Stäng fältlistan",
            "constantValueRequired": "Konstant värde krävs för fält: {field}",
            "noFieldsMappedWarning": "Inga fält är mappade. Mappa minst ett fält för M3-filtret eller ta bort M3-filtret."
        },
        "trigger": {
            "lookupAlreadyExists": "Uppslagsnamnet finns redan. Vänligen välj ett unikt namn.",
             "lookupNameRequired": "Lookup namn är obligatoriskt",
            "selectNewWorkflow": "Select new workflow to create trigger",
            "selectSource": "Select source",
            "lookupNotAvailable": "Uppslaget är inte tillgängligt. Arbetsflödet hittades inte eller är inaktivt.",
            "workflowNotFound":"The selected workflow is unavailable. Please choose a new workflow.",
            "noClientInputs": "Trigger: Please add at least one Client Input",
            "actions": "Åtgärder",
            "actionsRequired": "Actions is a mandatory field",
            "messages": {
                "triggerType": "TRIGGER: Please select a Trigger Type"
            },
            "title": "Trigger",
            "triggerConfiguration": "Trigger Configuration",
            "filtering": "Filtrering",
            "filterTooltip": "Du kan bara ha Filter eller Uttryck. Om du väljer det ena elimineras det andra",
            "emptyFilterPlaceholder": "Inga filter eller uttryck är tillämpade. Klicka på Filter eller Uttryck för att skapa ett villkor. Att välja en kommer att eliminera den andra",
            "addFilter": "Lägg till filter",
            "maximizeEditor": "Maximera redigeraren",
            "invalidExpression": "Ogiltigt JSONata-uttryck",
            "events": {
                "FILTER": "Filter",
                "EXPRESSION": "Uttryck"
            },
            "nextRuns": "Nästa schemalagda körningar",
            "start": "Startdatum/tid",
            "end": "Slutdatum/tid",
            "scheduledWorkflowRuns": "Schemalagda arbetsflödeskörningar",
            "scheduleDescription": "Ange hur ofta du vill schemalägga arbetsflödet att köras",
            "scheduledRuns": "Schemalagda körningar",
            "noScheduledRuns": "Inga schemalagda körningar",
            "clearSelection": "Rensa val",
            "replaceNotAvailable": "Utlöserhändelser är inte tillgängliga för REPLACE",
            "noEventColumnsAvailable": "No event columns available. Please configure an Event trigger with columns first."
        },
        "updateUserInstructions": "Uppdatering",
        "userInstructions": "Användarinstruktioner",
        "saveUserInstructions": "Instruktionerna har sparats",
        "value": "Value",
        "version": "Version",
        "searchEnvironments": "Search environments",
        "loadErrorEnvironments": "Det gick inte att läsa in miljöer",
        "loadErrorEnvironmentsPermission": "Du har inte behörighet att läsa in miljöer. Kontakta din administratör.",
        "loadErrorConnections": "Det gick inte att läsa in anslutningar",
        "loadErrorConnectionsPermission": "Du har inte behörighet att läsa in anslutningar. Kontakta din administratör.",
        "templates": {
            "exportToExcel": {
                "title": "Export from M3 API",
                "description": "Export from a M3 API through a filter into a table"
            },
            "importToApi": {
                "title": "Import to M3 API",
                "description": "Import from the M3 API into a table"
            },
            "apiToTable": {
                "title": "Store data from M3 to Table",
                "description": "Export from the M3 API into a table"
            },
            "onAPI": {
                "title": "M3 API",
                "description": "Connect directly to the M3 API"
            },
            "transform": {
                "title": "Transform",
                "description": "Process and transform data between systems"
            },
            "empty": {
                "title": "Blank Start",
                "description": "Build a workflow from scratch"
            }
        },
        "templateGroups": {
            "multi": "Multi Component Templates",
            "single": "Single Component Templates"
        },
        "nameAndDescription": "Details",
        "template": "Templates",
        "labels": "Etiketter",
        "addLabel": "Add a Label",
        "workflowInfo": "Workflow Info",
        "configuration": "Configuration",
        "options": "Options",
        "widget": {
            "addNewState": "Add new state",
            "additionalInfo": "Färg för alla textfält och ikon",
            "aggregateType": "Aggregate Type",
            "backgroundColor": "Bakgrundsfärg",
            "color": "Färg",
            "count": "Count",
            "createWidget": "Create widget",
            "customBackgroundColor": "Lägg till anpassad bakgrundsfärg",
            "dashboardUpdateInterval": "Dashboard update interval(seconds)",
            "data": "Data",
            "dataCount": "Font size for data count",
            "defaultBackgroundColor": "Standard bakgrundsfärg",
            "deleteDraft": "Delete draft",
            "displayValue": "Display Value",
            "documentation": "Documentation",
            "editState": "Edit state",
            "fontSize": "Font Size",
            "foregroundColor": "Förgrundsfärg",
            "icon": "Icon",
            "iconSettings": "Icon settings",
            "interval": "Interval",
            "label": "Label",
            "labelsMax": "labels (max 25)",
            "max": "Max",
            "min": "Min",
            "newState": "New state",
            "noStatesDefined": "No states are defined",
            "normalized": "Normalized",
            "pollingCountWithoutChanges": "Polling count without changes before warning",
            "range": "Range",
            "rangeFrom": "Range from",
            "rangeTo": "Range to",
            "scales": "Scales",
            "selectWidgetType": "Select widget type",
            "show": "Show",
            "sortBy": "Sort By",
            "stacked": "Stacked",
            "states": "States",
            "tableName": "Custom Tables",
            "titleSize": "Header font size",
            "type": "Type",
            "viewDetails": "View details",
            "widgetField": "Field",
            "widgetTitle": "Title",
            "xAxisConfigure": "Configure X-Axis",
            "yAxisConfigure": "Configure Y-Axis"
        },
        "workflow": "Workflow",
        "workflowActions": {
            "downloadTemplate": "Download Template",
            "execute": "Execute",
            "log": "logga",
            "manageRoles": "Manage roles",
            "move": "Move",
            "reRun": "Re-run",
            "rename": "Rename",
            "run": "Run",
            "schedule": "Schedule"
        },
        "workflowDescription": "Workflow description",
        "copyInfo": "Du kan antingen ändra arbetsflödets namn eller använda det föreslagna namnet för att fortsätta.",
        "copyWorkflow": "Kopiera arbetsflöde",
        "enterCopyName": "Arbetsflödets namn",
        "nameExists": "Arbetsflödets namn används redan. Vänligen välj ett unikt namn.",
        "copySuccess": "Arbetsflödet '{name}' har kopierats.",
        "copyError": "Misslyckades med att kopiera arbetsflödet.",
        "workflowName": "Workflow Name",
        "workflowType": "Workflow Type",
        "workflowTypeOptions": {
            "EXPRESS": "Express",
            "STANDARD": "Hög volym"
        },
        "useDedicatedIP": "Använd dedikerad IP",

        "ignoreExportMi": "Ignorera EXPORTMI-uppslag",
        "longRunning": "Lång körning",
        "longRunningMessage": "Hantera långvariga och högkapacitetsarbetsbelastningar",
        "expressMessage": "Bra för snabba operationer men kan misslyckas vid långa eller tunga arbetsbelastningar på grund av tidsbegränsningar.",
        "longRunningTooltip": "Aktivera för stora Excel-importer (30 000+ rader) som kan överstiga 15 minuter."
    },
    "webhooks": {
        "newWebhook": "Ny Webhook",
        "name": "Webhook-namn",
        "description": "Beskrivning",
        "editWebhook": "Redigera Webhook",
        "webhookDetails": "Webhook-detaljer",
        "messages": {
            "deleteWebhookConfirmation": "Vill du ta bort webhooken {webhookName}?",
            "deleteWebhookSuccess": "Webhook raderades framgångsrikt",
            "webhookNameExists": "Webhook-namn {webhookName} finns redan",
            "webhookNameRequired": "Webhook-namn krävs",
            "workflowRequired": "Välj ett arbetsflöde från rullgardinsmenyn",
            "copied": "Kopierad till urklipp",
            "copyError": "Misslyckades med att kopiera",
            "success": "Webhook sparades framgångsrikt",
            "errorOccurred": "Ett fel inträffade vid sparande av webhooken"
        },
        "title": "Webhooks",
        "webhookName": "Webhook-namn",
        "workflow": "Arbetsflöde",
        "webhookUrl": "Webhook URL",
        "tokenUrl": "Webhook-URL (med token)",
        "triggerHelp": "Skicka en POST-förfrågan till URL:en nedan för att utlösa detta arbetsflöde.",
        "basicAuthFallback": "Använd Basic Auth istället",
        "username": "Användarnamn",
        "password": "Lösenord",
        "token": "Token",
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "restrictedAccess": "Begränsad åtkomst",
        "invalidWorkflow": "Ogiltigt arbetsflöde",
        "activateSuccess": "Webhook aktiverades framgångsrikt",
        "deactivateSuccess": "Webhook inaktiverades framgångsrikt",
        "createWebhook": "Skapa Webhook",
        "noWebhooks": "Inga webhooks konfigurerade för detta arbetsflöde"
    },
    "groups": {
        "title": "Grupper",
        "noGroupedFields": "Inga grupperade fält hittades",
        "newGroup": "Ny Grupp",
        "editGroup": "Redigera Grupp",
        "groupName": "Gruppnamn",
        "workflows": "Workflows",
        "roles": "Roller",
        "selectWorkflows": "Välj Workflows",
        "tooltip": "Välj ordningen på workflows som ska visas i VXL Live",
        "selected": "Valda Workflows",
        "workflowName": "Workflow Namn",
        "createdByUser": "Skapad Av",
        "modifiedBy": "Ändrad Av",
        "created": "Skapad",
        "modified": "Ändrad",
        "messages": {
            "groupNameRequired": "Gruppnamn är obligatoriskt.",
            "groupNameExists": "Gruppen {groupName} finns redan!",
            "groupNameCheckFailed": "Det gick inte att verifiera gruppnamnet. Försök igen.",
            "rolesRequired": "Minst en roll måste väljas.",
            "deleteGroupConfirmation": "Är du säker på att du vill ta bort gruppen '{groupName}'?",
            "deleteGroupSuccess": "Gruppen togs bort.",
            "success": "Gruppen sparades.",
            "workflowsRequired": "Minst en workflow måste väljas."
        }
    },
    "workflowStatistics": {
        "statistics": "Arbetsflödesstatistik",
        "lastExecutionTime": "Senaste körningstid",
        "lastSuccessfulTime": "Senaste lyckade körning",
        "lastFailedTime": "Senaste misslyckade körning",
        "totalRuns": "Totala körningar",
        "totalRunsTooltip": "Totalt antal arbetsflödeskörningar",
        "successfulRunsTooltip": "Lyckade arbetsflödeskörningar",
        "failedRunsTooltip": "Misslyckade arbetsflödeskörningar",
        "viewLog": "Visa logg"
    }
}
